import { encode as base64_encode } from "base-64";
import config from "../config";
import { message } from "antd";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class DetailedJobStore {
  loading = false;
  total = 0;
  detailedJobData = [];
  tripData = [];
  remaning_vehicleId = ""
  remaning_driverId = ""
  last_record_timestamp = ""
  pythonReportMessage = false
  pythonReportErrorMessage=false
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      detailedJobData: observable,
      tripData: observable,
      remaning_vehicleId: observable,
      remaning_driverId: observable,
      last_record_timestamp: observable,
      loadData: action,
      loadTripData: action,
      exportExcel: action,
      exportpdf: action,
      pythonReportMessage: observable,
      pythonReportErrorMessage: observable
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    driverId,
    filterBy,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
    hasInvoice,
  }) {
      this.loading = true;
      var postData = {
        companyId: companyId,
        vehicleId: vehicleId,
        driverId: driverId,
        filterBy: filterBy,
        fromDate: fromDate,
        toDate: toDate,
        offset: offset,
        limit: limit,
        pageNo: pageNo,
        hasInvoice: hasInvoice,
      };

      if (offset === 0) {
        postData.last_record_timestamp = ""
        postData.remaning_vehicleId = ""
        postData.remaning_driverId = ""
      } else {
        postData.last_record_timestamp = this.last_record_timestamp
        postData.remaning_vehicleId = this.remaning_vehicleId
        postData.remaning_driverId = this.remaning_driverId
      }

      var response = await postApi.getClient('report').post("/fleet_report/detailedJobReport", postData);

      if (config.pythonReport === 1) {
          this.last_record_timestamp = response?.data?.data?.last_record_timestamp
          this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
          this.remaning_driverId = response?.data?.data?.remaning_driverId
      }

      this.detailedJobData = response?.data?.data?.dailytripreport;
      // this.total = parseInt(response?.data?.data?.TotalCount);
      this.loading = false;
  }

  async loadTripData({ vehicleId, fromDate, toDate, status }) {
    this.loading = true;
    var postData = {
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      driverId: null,
      status: status,
    };

    var response = await postApi.getClient('report').post("/fleet_report/getDailyTripSheet", postData);

    this.tripData = response?.data?.data;
    this.loading = false;
  }

  async exportExcel(getData) {

      getData = { ...getData, language: "english" }
          
      try {

        await postApi.getClient("report").post("/fleet_report/detailedJobReport/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

  }

  async exportpdf(getData) {

      getData = { ...getData, language: "english" }

      try {

        await postApi.getClient("report").post("/fleet_report/detailedJobReport/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

  }

}

export default DetailedJobStore;
